/* eslint-disable react/no-unused-prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import { useSelector, Provider } from 'react-redux'
import { CircularProgress } from '../components/Controls'
import { createReduxDataAndStore } from '../virtusa-redux'
import { ScreenCover, CenterDivOnScreen } from '../styles'
import { busyCursorZIndex, screenBlockerZIndex } from '../common'

let consoleOn = false    
if (process.env.NODE_ENV === 'production') {
  consoleOn = false 
}

const reducerKey = 'GlobalBusyCursor'

// Define the redux initial state at the reducer key
const initialState = {
  busyIncrement: 0,
  blocking: 0
}

const { setState, getState, store } = createReduxDataAndStore(reducerKey, initialState)

const busyIncrementSelector = () =>
  getState().busyIncrement

const blockingSelector = () =>
  getState().blocking

export const setBusy = location => {
  if (consoleOn) {
    // eslint-disable-next-line no-console
    console.log('setBusy', location, getState().busyIncrement)
  }
  setState({ busyIncrement: getState().busyIncrement + 1 })
}

export const clearBusy = location => {
  if (consoleOn) {
    // eslint-disable-next-line no-console
    console.log('clearBusy', location, getState().busyIncrement)
  }
  const state = getState()
  if (state.busyIncrement === 0) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('clearBusy: busyIncrement is zero.')
    }
    return
  }
  setState({ busyIncrement: state.busyIncrement - 1 })
}

export const setBlocking = location => {
  if (consoleOn) {
    // eslint-disable-next-line no-console
    console.log('setBlocking', location, getState().blocking)
  }
  setState({ blocking: getState().blocking + 1 })
}

export const clearBlocking = location => {
  if (consoleOn) {
    // eslint-disable-next-line no-console
    console.log('clearBlocking', location, getState().blocking)
  }
  const state = getState()
  if (state.blocking === 0) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('clearBlocking: blocking is zero.')
    }
    return
  }
  setState({ blocking: state.blocking - 1 })
}

const BaseGlobalBusyCursor = () => {
  const busyIncrement = useSelector(busyIncrementSelector)
  if (busyIncrement === 0) {
    return null
  }
  return (
    <ScreenCover zIndex={busyCursorZIndex}>
      <CenterDivOnScreen>
        <CircularProgress />
      </CenterDivOnScreen>
    </ScreenCover>
  )
}

/**
 * Implements a busy cursor that can be turned on and off with the exported functions setBusy and clearBusy. There is no need to include the component into your page since it is installed into the root of the App tree.
 *
 * @returns {GlobalBusyCursor} GlobalBusyCursor component
 */
const GlobalBusyCursor = () => {
  return (
    <Provider store={store}>
      <BaseGlobalBusyCursor />
    </Provider>
  )
}

GlobalBusyCursor.propTypes = {
  /**
   Exported function from this module.<br/>
   Call this function to display a loading/busy spinning cursor.<br/>
   */
  setBusy: PropTypes.func,
  /**
   Exported function from this module.<br/>
   Call this function to remove the loading/busy spinning cursor.<br/>
   */
  clearBusy: PropTypes.func,
}

export const BaseScreenBlocker = () => {
  const blocking = useSelector(blockingSelector)
  if (blocking === 0) {
    return null
  }
  return (
    <Provider store={store}>
      <ScreenCover zIndex={screenBlockerZIndex} />
    </Provider>
  )
}

export const ScreenBlocker = () => {
  return (
    <Provider store={store}>
      <BaseScreenBlocker />
    </Provider>
  )
}

export default GlobalBusyCursor
